import { Component, Directive, ElementRef, inject, Injector, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    selector: 'event-types-list-directive',
    standalone: false,
})
export class EventTypesListDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('eventTypesList', elementRef, injector);
        console.log("EventTypesListDirective initialized");
    }
}

@Component({
    selector: 'event-types-list',
    template: '<event-types-list-directive></event-types-list-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EventTypesListComponent {
    constructor() {
        console.log("EventTypesListComponent initialized");
    }
}

@Directive({
    selector: 'event-type-form-directive',
    standalone: false,
})
export class EventTypeFormDirective extends UpgradeComponent {
    @Input() eventTypeId: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('eventTypeForm', elementRef, injector);
        console.log("EventTypeFormDirective initialized");
    }
}

@Component({
    selector: 'event-type-form',
    template: '<event-type-form-directive [eventTypeId]="id" [action]="action"></event-type-form-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EventTypeFormComponent {
    @Input() id: string;

    protected action: string;

    private route = inject(ActivatedRoute);

    constructor() {
        this.route.data.subscribe(data => {
            this.action = data['action'];
        });
    }
}

@Directive({
    selector: 'event-type-preview-directive',
    standalone: false,
})
export class EventTypePreviewDirective extends UpgradeComponent {
    @Input() eventTypeId: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('eventTypePreview', elementRef, injector);
        console.log("EventTypePreviewDirective initialized");
    }
}

@Component({
    selector: 'event-type-preview',
    template: '<event-type-preview-directive [eventTypeId]="eventTypeId"></event-type-preview-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EventTypePreviewComponent implements OnInit {
    eventTypeId: string;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        // Subscribe to route params to get the event type ID
        this.route.params.subscribe(params => {
            this.eventTypeId = params['id'] || null;
        });
    }
}

@Directive({
    selector: 'event-type-section-directive',
    standalone: false,
})
export class EventTypeSectionDirective extends UpgradeComponent {
    @Input() eventTypeId: string;
    @Input() sectionId: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('eventTypeSection', elementRef, injector);
        console.log("EventTypeSectionDirective initialized");
    }
}

@Component({
    selector: 'event-type-section',
    template: '<event-type-section-directive [eventTypeId]="eventTypeId" [sectionId]="sectionId"></event-type-section-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EventTypeSectionComponent implements OnInit {
    eventTypeId: string;
    sectionId: string;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        // Subscribe to route params to get the event type ID and section ID
        this.route.params.subscribe(params => {
            this.eventTypeId = params['id'] || null;
            this.sectionId = params['sectionId'] || null;
        });
    }
}

@Directive({
    selector: 'event-type-section-field-directive',
    standalone: false,
})
export class EventTypeSectionFieldDirective extends UpgradeComponent {
    @Input() eventTypeId: string;
    @Input() sectionId: string;
    @Input() fieldId: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('eventTypeSectionField', elementRef, injector);
        console.log("EventTypeSectionFieldDirective initialized");
    }
}

@Component({
    selector: 'event-type-section-field',
    template: '<event-type-section-field-directive [eventTypeId]="eventTypeId" [sectionId]="sectionId" [fieldId]="fieldId"></event-type-section-field-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EventTypeSectionFieldComponent implements OnInit {
    eventTypeId: string;
    sectionId: string;
    fieldId: string;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        // Subscribe to route params to get the event type ID, section ID, and field ID
        this.route.params.subscribe(params => {
            this.eventTypeId = params['id'] || null;
            this.sectionId = params['sectionId'] || null;
            this.fieldId = params['fieldId'] || null;
        });
    }
}

@Directive({
    selector: 'event-type-section-predefined-fields-directive',
    standalone: false,
})
export class EventTypeSectionPredefinedFieldsDirective extends UpgradeComponent {
    @Input() eventTypeId: string;
    @Input() sectionId: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        console.log("EventTypeSectionPredefinedFieldsDirective initializing");
        super('eventTypePredefinedFields', elementRef, injector);
        console.log("EventTypeSectionPredefinedFieldsDirective initialized");
    }
}

@Component({
    selector: 'event-type-section-predefined-fields',
    template: '<event-type-section-predefined-fields-directive [eventTypeId]="eventTypeId" [sectionId]="sectionId"></event-type-section-predefined-fields-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EventTypeSectionPredefinedFieldsComponent implements OnInit {
    eventTypeId: string;
    sectionId: string;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        // Subscribe to route params to get the event type ID and section ID
        this.route.params.subscribe(params => {
            this.eventTypeId = params['id'] || null;
            this.sectionId = params['sectionId'] || null;
        });
    }
}
